  <template>
  <!-- dashboard -->
  <v-card class="w-100 dashboard">
    <!-- panel panel-flat -->
      <!-- breadcrumb-line -->
      <v-toolbar flat class="sub-toolbar elevation-0">
         <!-- Descartar -->
            <v-btn
              v-if="editable"
              flat
              text
              class="primary-color back mr-auto"
              @click="cambiarEditable(false, false)"
            >
            <v-icon class="mr-2">arrow_back</v-icon>
              {{ $t("lang.comun.salir") }}
            </v-btn>
        <!-- Migas -->
        <!-- <ul class="breadcrumb">
          <li>
            <i class="icon-home2 position-left"></i>
            {{ $t("lang.home.dashboard") }}
          </li>
        </ul> -->
        <!-- //Migas -->
        <!---->
        <!-- <div class="titulo" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">
            <i class="icon-chevron-left" v-if="hayTiendaAnterior()" @click="tiendaAnterior()"></i>
              <h3>{{bip_item_id}} - Nombre OP</h3>
            <i class="icon-chevron-right" v-if="hayTiendaSiguiente()" @click="tiendaSiguiente()"></i>
        </div> -->
        <!----> <!-- //Botones edicion -->
          <!-- Anhadir elementos -->
          <v-card class="dropdown d-flex align-center" v-if="editable" flat>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    href="javascript:"
                    class="elevation-0  primary-color rounded-0 ma-0"
                  >
                    <v-icon class="mr-2 ">add_circle</v-icon>
                    {{ $t("lang.home.addelemento") }}
                  </v-btn>
                </template>
                <v-list  class="pa-0" 
                     v-for="item in dropdownItems"
                    :key="item.id"
                    :class="{'disabled' : item.disabled}"
                  >
                    <v-divider class="ma-0"></v-divider>
                  <v-subheader 
                      tabindex="-1"
                      href="javascript:"
                      @click="item.id === 3 && !item.disabled ? addTopArticulosVendidosDashboard() : null"
                    >
                    <i :class="item.icon" class="mr-2"></i>
                    {{ item.name }}
                  </v-subheader>
                <v-list  class="pa-0" v-if="item.children">
                  <v-list-tile
                    v-for="child in item.children"
                    :key="child.id"
                    :class="{ 'disabled' : child.id === 0 }"
                  >
                    <a
                      tabindex="-1"
                      @click="item.id === 1 && child.id !== 0 ? addPildoraDashboard(child.id) : item.id === 2 && child.id !== 0 ? addEchartDashboard(child.id) : item.id === 4 && child.id !== 0 ? addTablaDashboard(child.id) : item.id === 5 && child.id !== 0 ? addPhoneServiceDashboard(child) : null"
                    >{{child.name}}</a>
                  </v-list-tile>
                </v-list>
                </v-list>
              </v-menu>
       <!--   <a
              href="javascript:"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="icon-add position-left"></i>
              {{ $t("lang.home.addelemento") }}
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li
                v-for="item in dropdownItems"
                :key="item.id"
                class="dropdown-submenu left-submenu"
                :class="{'disabled' : item.disabled}"
              >
                <a
                  tabindex="-1"
                  href="javascript:"
                  @click="item.id === 3 && !item.disabled ? addTopArticulosVendidosDashboard() : null"
                >
                  <i :class="item.icon"></i>
                  {{ item.name }}
                </a>
                <ul class="dropdown-menu" v-if="item.children">
                  <li
                    v-for="child in item.children"
                    :key="child.id"
                    :class="{ 'disabled' : child.id === 0 }"
                  >
                    <a
                      tabindex="-1"
                      @click="item.id === 1 && child.id !== 0 ? addPildoraDashboard(child.id) : item.id === 2 && child.id !== 0 ? addEchartDashboard(child.id) : item.id === 4 && child.id !== 0 ? addTablaDashboard(child.id) : item.id === 5 && child.id !== 0 ? addPhoneServiceDashboard(child) : null"
                    >{{child.name}}</a>
                  </li>
                </ul>
              </li>
            </ul>-->
          </v-card>
              
        <!-- Edicion -->
        <v-card class="mb-0 transparent" flat>
          <!-- Botones edicion -->
          <!-- Spinner -->
          <li v-if="cargando">
            <Spinner size="25" class="pt-5"/>
          </li>
          <!-- //Spinner -->
       
         
        </v-card>
          <!-- //Anhadir elementos -->
          <!-- Opciones -->
          <!-- <li class="dropdown" v-if="!editable">
            <a
              href="javascript:"
              class="dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="icon-gear position-left"></i>
              <span class="caret"></span>
            </a>
            <ul class="dropdown-menu dropdown-menu-right"> -->
              <!-- Modificar dashboard -->
              <!-- <li class="dropdown-submenu left-submenu"> -->
                 <v-btn
                  tabindex="-1"
                  @click="!editable ? refrescarDatos() : null"
                  v-show="!editable"
                  class=" ma-0 primary-color"
                  flat
                  text
                ><v-icon class="mr-2">rotate_left</v-icon>
                  {{ $t("lang.home.refrescardatos") }}
                </v-btn>
                <v-btn
                  tabindex="-1"
                  @click="!editable ? cambiarEditable(true, false) : null"
                  v-show="!editable"
                  class="ma-0 primary-color"
                  v-if="permitido('MOBILESTORE.BI.MODIFDASHBOARD')"
                  flat
                  text
                >
                  <v-icon class="mr-2">dashboard_customize</v-icon>
                    {{ $t("lang.home.modificardashboard") }}
                  </v-btn>
              <!-- </li> -->
              <!-- //Modificar dashboard -->
              <!-- Refrescar datos -->
              <!-- <li class="dropdown-submenu left-submenu"> -->
               
              <!-- </li> -->
              <!-- //Refrescar datos -->
            <!-- </ul>
          </li> -->
          <!-- //Opciones -->
        
        <!-- //Edicion -->
      </v-toolbar>
      <!-- //breadcrumb-line -->
      <!-- panel-body -->
      <div class="py-3 px-3">
        <!-- content -->
        <div
          class="content"
          style="height: 100%;"
          :class="{ 'vue-grid-layout-editando': editable }"
          v-if="contentLayout.length > 0"
        >
          <!-- grid-layout -->
          <grid-layout
            :layout.sync="contentLayout"
            :col-num="contentConfig.colNum"
            :row-height="contentConfig.rowHeight"
            :is-draggable="contentConfig.draggable"
            :is-resizable="contentConfig.resizable"
            :is-mirrored="contentConfig.mirrored"
            :vertical-compact="contentConfig.verticalCompact"
            :margin="contentConfig.margin"
            :responsive="contentConfig.responsive"
            :use-css-transforms="contentConfig.useCssTransforms"
            :class="{ 'vue-grid-layout-editando': editable }"
            :style="`height: ${gridLayoutHeight}px !important;`"
          >
            <grid-item
              v-for="itemContentLayout in contentLayout"
              :x="itemContentLayout.x"
              :y="itemContentLayout.y"
              :w="itemContentLayout.w"
              :h="itemContentLayout.h"
              :i="itemContentLayout.i"
              :key="itemContentLayout.i"
              :dragAllowFrom="'.vue-draggable-handle'"
              @moved="movedEvent"
              @resized="resizedEvent"
            >
              <template>
                <component
                  :is="itemContentLayout.c"
                  :editable="editable"
                  :collapsed="itemContentLayout.collapsed"
                  :config="itemContentLayout.config"
                  :data="itemContentLayout.data"
                  :altura="itemContentLayout.h"
                  :id="itemContentLayout.idComponent"
                  :refrescar="refrescar"
                  @collapse="onClickCollapse"
                  @collapseTabla="onClickCollapseTabla"
                  @eliminarpildora="onClickRemovePildora(itemContentLayout.idComponent)"
                  @eliminarechart="onClickRemoveEChart(itemContentLayout.idComponent)"
                  @eliminartoparticulosvendidos="onClickRemoveTopArticulosVendidos(itemContentLayout.idComponent)"
                  @eliminartabla="onClickRemoveTabla(itemContentLayout.idComponent)"
                  @eliminarventaneta="onClickRemoveVentaNeta(itemContentLayout.idComponent)"
                  @eliminaranalisistienda="onClickRemoveAnalisisTienda(itemContentLayout.idComponent)"
                  @eliminaranalisisseccion="onClickRemoveAnalisisSeccion(itemContentLayout.idComponent)"
                ></component>
              </template>
            </grid-item>
          </grid-layout>
          <!-- grid-layout -->
        </div>
        <div
          class="content alineado-derecha"
          :class="{ 'vue-grid-layout-editando': editable }"
          v-else
        >
          <!-- <h1
            style="color: grey;"
          >{{ !editable ? "Haga click en el icono para modificar el dashboard" : "" }}</h1>&nbsp;
          <i class="glyphicon glyphicon-arrow-up" style="font-size: 30px;" v-if="!editable"></i> -->
        </div>
        <!-- //content -->
      </div>
      <!-- //panel panel-flat -->
  
            <!-- Guardar -->
            <v-btn
               v-if="editable"
               fab
               dark
               large
               absolute
               bottom
               right
               class="orange guardar"
              @click="cambiarEditable(false, true)"
            >
              <v-icon>save</v-icon>
              <!--{{ $t("lang.comun.guardar") }}-->
            </v-btn>
            <!-- //Guardar -->
           
            <!-- //Descartar -->
      
    <!-- //panel-body -->
  </v-card>
  <!-- //dashboard -->
</template>
<script>
import { BiApiService } from "@/api/BiApiService";
import { Util } from "@/api/Util";
import Pildora from "@/components/Pildora.vue";
import Grafico from "@/components/Grafico.vue";
import VentaNeta from "@/components/VentaNeta.vue";
import AnalisisTienda from "@/components/AnalisisTienda.vue";
import AnalisisSeccion from "@/components/AnalisisSeccion.vue";
import Tabla from "@/components/Tabla.vue";
import TopArticulosVendidos from "@/components/TopArticulosVendidos.vue";
import EChart from "@/components/EChart.vue";
import VueGridLayout from "vue-grid-layout";
import Spinner from "vue-simple-spinner";

// Importamos los archivos JSON
// import pildorasJSON from "@/assets/data/pildoras.json";
// import echartsJSON from "@/assets/data/echarts.json";
// import tablasJSON from "@/assets/data/tablas.json";

const biApiService = new BiApiService();
const util = new Util();

window.addEventListener("orientationchange", function() {
    // Announce the new orientation number
    location.reload();
}, false);

export default {
  components: {
    Pildora,
    Grafico,
    VentaNeta,
    AnalisisTienda,
    AnalisisSeccion,
    TopArticulosVendidos,
    Tabla,
    EChart,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Spinner
  },
  data() {
    return {
      // General
      refrescar: 0,
      editable: false,
      cargando: true,
      // Numero maximo de filas que tendra el grid
      matrizOcupacionMaxRows: 100,
      // Pildoras
      pildorasJSON: [],
      totalPildorasJSON: 0,
      pildorasDisponibles: [],
      siguientePosicionPequenha: {},
      widthPildora: 1,
      heightPildora: 2,
      pildoraDataList: [],
      // ECharts (echarts)
      echartsJSON: [],
      totalEChartsJSON: 0,
      echartsDisponibles: [],
      siguientePosicionGrande: {},
      widthEChart: 4,
      heightEChart: 5,
      graficoDataList: [],
      // TopArticulosVendidos
      widthTopArticulosVendidos: 4,
      heightTopArticulosVendidos: 4,
      // Tabla
      tablasJSON: [],
      totalTablasJSON: 0,
      tablasDisponibles: [],
      widthTabla: 4,
      heightTabla: 5,
      // Phone service
      widthPhone: 2,
      heightPhone: 4,
      // Otros
      dropdownItems: [], // Lista de elementos
      bip_item_id: this.$store.getters.getIdTienda, // Numero por defecto
      gridLayoutHeight: 250, // altura del grid por defecto
      // Content
      contentConfig: {
        colNum: 4, // Numero de columnas del grid
        rowHeight: 74, // Altura (pxs) de cada fila del grid
        draggable: false, // Variable que permite arrastrar los elementos
        resizable: false, // Variable que permite cambiar el tamanho de los elementos
        mirrored: false,
        verticalCompact: true,
        margin: [5, 40],
        useCssTransforms: true,
        responsive: false
      },
      contentLayout: [],
      contentLayoutRevert: []
    };
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getIdTienda;
    }
  },
  watch: {
    cambiotienda (value) {
      this.bip_item_id = value;
      this.generateDropdownItems();
      this.getContentLayout();
      this.calculategridLayoutHeight();
      this.getSiguientePosicionItem();
    }
  },
  created() {
    this.cambioTitulo();
    this.getAllJson();
    this.generateDropdownItems();
    this.getContentLayout();
    this.getIdTienda();
    this.calculategridLayoutHeight();
    this.getSiguientePosicionItem();
  },
  mounted() {
    this.getAllPildoraByIdsAndItemId();
    this.getAllMejoresVentasOp();
    this.getAllGraficosByIdsAndItemId();
    this.getAllTablaByIdsAndItemId();
  },
  methods: {
    // swipeLeft() {
    //   if (this.hayTiendaAnterior()) {
    //     this.tiendaAnterior()
    //   }
    // },
    // swipeRight() {
    //   if (this.hayTiendaSiguiente()) {
    //     this.tiendaSiguiente()
    //   }
    // },
    // hayTiendaAnterior(){
    //   if (this.listaBipIds.indexOf(this.bip_item_id)>0)
    //     return true;
    //   else  
    //     return false;
    // },
    // hayTiendaSiguiente(){
    //    if (this.listaBipIds.indexOf(this.bip_item_id)<this.listaBipIds.length-1)
    //     return true;
    //   else  
    //     return false;
    // },
    // tiendaAnterior(){
    //   let idAux=this.listaBipIds[this.listaBipIds.indexOf(this.bip_item_id)-1];
    //   // this.$router.push({ path: 'dashboard', query: { tienda: idAux } });
    //   // this.$router.go();
    //   this.bip_item_id = idAux;
    //   this.generateDropdownItems();
    //   this.getContentLayout();
    //   this.calculategridLayoutHeight();
    //   this.getSiguientePosicionItem();
    // },
    // tiendaSiguiente(){
    //   let idAux=this.listaBipIds[this.listaBipIds.indexOf(this.bip_item_id)+1];
    //   // this.$router.push({ path: 'dashboard', query: { tienda: idAux } });
    //   // this.$router.go();
    //   this.bip_item_id = idAux;
    //   this.generateDropdownItems();
    //   this.getContentLayout();
    //   this.calculategridLayoutHeight();
    //   this.getSiguientePosicionItem();
    // },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">stacked_bar_chart</v-icon>`
      this.$store.state.titulo = this.$t('lang.home.dashboard')
    },
    getAllJson() {
      // recogemos los json con todas las pildoras gráficos y metavistas

      // CAMBIO ahora las pildoras se cogen en la base de datos ya no se utiliza el json ***///
      // biApiService
      //     .getPildorasJson()
      //     .then(data => {
      //       console.log(data)
      //       this.pildorasJSON=data;
      //       util.mostrarEnConsola(
      //         "Dashboard - getPildorasJson",
      //         //data,
      //         "OK"
      //       );
      //     })
      //     .catch(error => {
      //       util.mostrarEnConsola(
      //         "Dashboard - getPildorasJson",
      //         error,
      //         "ERROR"
      //       );
      //     });
      biApiService
        .getPildorasConfig()
        .then(data => {
          // console.log(data)
          this.pildorasJSON=data;
          // util.mostrarEnConsola(
          //   "Dashboard - getPildorasConfig",
          //   //data,
          //   "OK"
          // );
        })
        .catch(error => {
          util.mostrarEnConsola(
            "Dashboard - getPildorasConfig",
            error,
            "ERROR"
          );
        });
      biApiService
          .getGraficosJson()
          .then(data => {
            // console.log(data)
            this.echartsJSON=data;
            // util.mostrarEnConsola(
            //   "Dashboard - getGraficosJson",
            //   //data,
            //   "OK"
            // );
          })
          .catch(error => {
            util.mostrarEnConsola(
              "Dashboard - getGraficosJson",
              error,
              "ERROR"
            );
          });
      biApiService
          .getMetavistasJson()
          .then(data => {
            // console.log(data)
            this.tablasJSON=data;
            // util.mostrarEnConsola(
            //   "Dashboard - getMetavistasJson",
            //   //data,
            //   "OK"
            // );
          })
          .catch(error => {
            util.mostrarEnConsola(
              "Dashboard - getMetavistasJson",
              error,
              "ERROR"
            );
          });
    },
    getIdTienda() {
      // if (
      //   this.$route.query.tienda !== null &&
      //   this.$route.query.tienda !== undefined //&&
      //   //!isNaN(this.$route.query.tienda)
      // ) {
      //   this.bip_item_id = Number(this.$route.query.tienda);
      //   if (
      //     this.$cookies.get("idtienda") !== null &&
      //     this.$cookies.get("idtienda") !== undefined 
      //   ) {
      //     // if (this.bip_item_id !== Number(this.$cookies.get("idtienda")))
      //     // si se cambia el id de la tienda mediante la url se reincia el dashboard
      //     // this.contentLayout.length=0;
      //   }
      // } else {
      //   if (
      //     this.$cookies.get("idtienda") !== null &&
      //     this.$cookies.get("idtienda") !== undefined //&&
      //     //!isNaN(this.$route.query.tienda)
      //   ) {
      //     // Intentamos obtener el id
      //     this.bip_item_id = Number(this.$cookies.get("idtienda"));
      //   }
      // }
      // this.$cookies.set("idtienda", Number(this.bip_item_id));
    },
    refrescarDatos() {
      this.cambiarSpinner(true);
      this.getAllPildoraByIdsAndItemId();
      this.getAllMejoresVentasOp();
      this.getAllGraficosByIdsAndItemId();
      this.getAllTablaByIdsAndItemId();
      this.refrescarPhoneServices()
    },
    cambiarSpinner(value) {
      this.cargando = value;
    },
    onClickCollapse(value) {
      let diferencia = 0;
      let alturaY = 0;
      // Cambiar el tamanho del item
      this.contentLayout.forEach(contentLayoutItem => {
        if (
          contentLayoutItem.config.id === value.id &&
          contentLayoutItem.config.tipo === value.tipo
        ) {
          // Calculamos la diferencia de altura
          if (value.collapse) {
            diferencia = Math.abs(1 - contentLayoutItem.h);
            alturaY = contentLayoutItem.y;
            contentLayoutItem.h = 1;
            contentLayoutItem.collapsed = true;
          } else {
            diferencia = Math.abs(1 - contentLayoutItem.hReverse);
            alturaY = contentLayoutItem.y;
            contentLayoutItem.h = contentLayoutItem.hReverse;
            contentLayoutItem.collapsed = false;
          }
        }
      });

      // Movemos todos los items que se encuentren por debajo la diferencia de altura
      this.contentLayout.forEach(contentLayoutItem => {
        if (value.collapse) {
          if (contentLayoutItem.y > alturaY) {
            if (contentLayoutItem.y - diferencia > 0) {
              contentLayoutItem.y = contentLayoutItem.y - diferencia;
            }
          }
        } else {
          if (contentLayoutItem.y > alturaY) {
            contentLayoutItem.y = contentLayoutItem.y + diferencia;
          }
        }
      });

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Guardamos el layout
      localStorage.setItem("contentlayout", JSON.stringify(this.contentLayout));
    },
    onClickCollapseTabla(value) {
      let diferencia = 0;
      let alturaY = 0;
      // Cambiar el tamanho del item
      this.contentLayout.forEach(contentLayoutItem => {
        if (
          contentLayoutItem.config.id === value.id &&
          contentLayoutItem.config.tipo === value.tipo
        ) {
          // Calculamos la diferencia de altura
          if (value.collapse) {
            diferencia = Math.abs(1 - contentLayoutItem.h);
            alturaY = contentLayoutItem.y;
            contentLayoutItem.h = 1;
            contentLayoutItem.collapsed = true;
          } else {
            diferencia = Math.abs(1 - contentLayoutItem.hReverse);
            alturaY = contentLayoutItem.y;
            contentLayoutItem.h = contentLayoutItem.hReverse;
            contentLayoutItem.collapsed = false;
          }
        }
      });

      // Movemos todos los items que se encuentren por debajo la diferencia de altura
      this.contentLayout.forEach(contentLayoutItem => {
        if (value.collapse) {
          if (contentLayoutItem.y > alturaY) {
            if (contentLayoutItem.y - diferencia > 0) {
              contentLayoutItem.y = contentLayoutItem.y - diferencia;
            }
          }
        } else {
          if (contentLayoutItem.y > alturaY) {
            contentLayoutItem.y = contentLayoutItem.y + diferencia;
          }
        }
      });

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Guardamos el layout
      localStorage.setItem("contentlayout", JSON.stringify(this.contentLayout));
    },
    onClickRemovePildora(value) {
      this.removePildoraDashboard(value);
    },
    onClickRemoveEChart(value) {
      this.removeEChartDashboard(value);
    },
    onClickRemoveTopArticulosVendidos(value) {
      this.removeTopArticulosVendidos(value);
    },
    onClickRemoveTabla(value) {
      this.removeTabla(value);
    }, 
    onClickRemoveVentaNeta(value) {
      this.removeVentaNeta(value);
    },
    onClickRemoveAnalisisSeccion(value) {
      this.removeAnalisisSeccion(value);
    },
    onClickRemoveAnalisisTienda(value) {
      this.removeAnalisisTienda(value);
    },
    getContentLayout() {
      while (this.contentLayout.length > 0) {
          this.contentLayout.pop();
      }
      if (
        localStorage.getItem("contentlayout") !== null &&
        localStorage.getItem("contentlayout") != undefined
      ) {
        this.contentLayout = Array.from(JSON.parse(localStorage.getItem("contentlayout")));
        this.comprobarPermisos();
        this.refrescarDatos();
      } else {
        biApiService
          .getLayout()
          .then(data => {
            if (data !== '') {            
              this.contentLayout = data;
            } else {
              this.contentLayout = JSON.parse(this.getDashboardDefecto());
            }
            localStorage.setItem("contentlayout", JSON.stringify(this.contentLayout));
            this.comprobarPermisos();
            this.calculategridLayoutHeight();
            this.refrescarDatos();
          })
          .catch(error => {
            util.mostrarEnConsola(
              "Dashboard - getLayout",
              error,
              "ERROR"
            );
          });
      }
    },
    comprobarPermisos () {
      for (let j = 0; j < this.contentLayout.length; j++) {
        if (!this.permitido(this.contentLayout[j].nombrePermiso)){
          // Miramos si el usuario tiene permisos
          this.contentLayout.splice(j, 1);
        }
      }
    },
    cambiarEditable(cambiar, guardar) {
      if (cambiar) {
        // Modificamos las variables que permiten editar
        this.editable = true;
        this.contentConfig.draggable = true;

        // Guardamos el layout en cookie
        // this.setLayoutRevertCookie();
      } else {
        // Modificamos las variables que permiten editar
        this.editable = false;
        this.contentConfig.draggable = false;
        // this.contentConfig.resizable = false;
        if (guardar) {
          // quitamos los datos de los componentes para guardar por tamaño
          let contentLayoutAux = JSON.stringify(this.contentLayout)
          contentLayoutAux = JSON.parse(contentLayoutAux)
          for (let j = 0; j < contentLayoutAux.length; j++) {
            if (contentLayoutAux[j].c === 'Tabla' || contentLayoutAux[j].c === 'TopArticulosVendidos') {
              contentLayoutAux[j].data = []
            } else if (contentLayoutAux[j].c === 'Pildora' || contentLayoutAux[j].c === 'EChart') {
              contentLayoutAux[j].data = {}
            }
          }
          // Guardamos el layout
          localStorage.setItem(
            "contentlayout",
            JSON.stringify(contentLayoutAux)
          );
          biApiService
            .saveLayout(JSON.stringify(contentLayoutAux))
            .then(data => {
              // console.log(data)
              util.mostrarEnConsola(
                "Dashboard - saveLayout",
                data,
                "OK"
              );
            })
            .catch(error => {
              util.mostrarEnConsola(
                "Dashboard - saveLayout",
                error,
                "ERROR"
              );
            });
        } else {
          // Restablecemos el layout del localstorage
          // this.getLayoutRevertCookie();
        }
      }
      // Regeneramos la lista de items para anhadir
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();
    },
    setLayoutRevertCookie() {
      // Guardamos en cookie
      while (this.contentLayoutRevert.length > 0) {
        this.contentLayoutRevert.pop();
      }
      this.contentLayoutRevert = Array.from(this.contentLayout);

      // Guardamos en localstorage
      localStorage.setItem(
        "contentlayoutrevert",
        JSON.stringify(this.contentLayoutRevert)
      );
    },
    getLayoutRevertCookie() {
      if (
        localStorage.getItem("contentlayoutrevert") !== null &&
        localStorage.getItem("contentlayoutrevert") !== undefined
      ) {
        while (this.contentLayout.length > 0) {
          this.contentLayout.pop();
        }
        this.contentLayout = Array.from(
          JSON.parse(localStorage.getItem("contentlayoutrevert"))
        );
      }
    },
    // eslint-disable-next-line
    movedEvent: function(i, newX, newY) {
      this.getSiguientePosicionItem();
      this.calculategridLayoutHeight();
    },
    // eslint-disable-next-line
    resizedEvent: function(i, newH, newW, newHPx, newWPx) {
      this.getSiguientePosicionItem();
      this.calculategridLayoutHeight();
    },
    getMatrizOcupacion: function() {
      let matrizOcupacion = [];
      for (let i = 0; i < 100; i++) {
        matrizOcupacion[i] = new Array(false, false, false, false);
      }

      // Recorremos los elementos del grid y rellenamos la matriz de ocupacion
      if (this.contentLayout.length > 0) {
        for (let j = 0; j < this.contentLayout.length; j++) {
          let itemContentLayout = this.contentLayout[j];
          let posx = itemContentLayout.x;
          let posy = itemContentLayout.y;
          let altura = itemContentLayout.h;
          let anchura = itemContentLayout.w;
          for (let m = 0; m < anchura; m++) {
            for (let n = 0; n < altura; n++) {
              matrizOcupacion[posy + n][posx + m] = true;
            }
          }
        }
      }
      return matrizOcupacion;
    },
    getSiguientePosicionItem() {
      // Obtenemos la matriz de ocupacion
      let matrizOcupacion = this.getMatrizOcupacion();

      // Buscamos la primera posicion para pildora que sea false en la matriz de ocupacion
      let posicionPildoraEncontrada = false;
      loopPildora: for (let y = 0; y < this.matrizOcupacionMaxRows; y++) {
        for (let x = 0; x < 4; x++) {
          if (!matrizOcupacion[y][x]) {
            this.siguientePosicionPequenha = { x: x, y: y };
            posicionPildoraEncontrada = true;
            break loopPildora;
          }
        }
      }
      // Si no se ha encontrado, lo cual quiere decir que no hay ningun elemento en el grid, ponemos la posicion inicial
      if (!posicionPildoraEncontrada) {
        this.siguientePosicionPequenha = { x: 0, y: 0 };
      }

      // Buscamos la primera posicion para grafico que sea false en la matriz de ocupacion
      let posicionEchartEncontrada = false;
      loopGrafico: for (let y = 0; y < this.matrizOcupacionMaxRows; y++) {
        if (
          !matrizOcupacion[y][0] &&
          !matrizOcupacion[y][1] &&
          !matrizOcupacion[y][2] &&
          !matrizOcupacion[y][3]
        ) {
          this.siguientePosicionGrande = { x: 0, y: y };
          posicionEchartEncontrada = true;
          break loopGrafico;
        }
      }
      // Si no se ha encontrado, lo cual quiere decir que no hay ningun elemento en el grid, ponemos la posicion inicial
      if (!posicionEchartEncontrada) {
        this.siguientePosicionGrande = { x: 0, y: 0 };
      }
    },
    getPildorasDisponibles() {
      while (this.pildorasDisponibles.length) {
        this.pildorasDisponibles.pop();
      }
      this.totalPildorasJSON = 0;
      for (let i = 0; i < this.pildorasJSON.length; i++) {
        const pildoraJSON = this.pildorasJSON[i];
        this.totalPildorasJSON++;
        let encontrado = false;
        if (this.permitido(pildoraJSON.bip_nombrePermiso)) {
          loopj: for (let j = 0; j < this.contentLayout.length; j++) {
            const contentLayoutItem = this.contentLayout[j];
            if (
              contentLayoutItem.c === "Pildora" &&
              contentLayoutItem.idComponent === pildoraJSON.bip_id
            ) {
              encontrado = true;
              break loopj;
            }
          }
          if (!encontrado) {
            this.pildorasDisponibles.push(pildoraJSON);
          }
        }
      }
    },
    getEChartsDisponibles() {
      while (this.echartsDisponibles.length) {
        this.echartsDisponibles.pop();
      }
      this.totalEChartsJSON = 0;
      for (let i = 0; i < this.echartsJSON.length; i++) {
        const echartJSON = this.echartsJSON[i];
        this.totalEChartsJSON++;
        let encontrado = false;
        if (this.permitido(echartJSON.nombrePermiso)) {
          loopj: for (let j = 0; j < this.contentLayout.length; j++) {
            const contentLayoutItem = this.contentLayout[j];
            if (
              contentLayoutItem.c === "EChart" &&
              contentLayoutItem.idComponent === echartJSON.id
            ) {
              encontrado = true;
              break loopj;
            }
          }
          if (!encontrado) {
            this.echartsDisponibles.push(echartJSON);
          }
        }  
      }
    },
    getTablasDisponibles() {
      while (this.tablasDisponibles.length) {
        this.tablasDisponibles.pop();
      }
      this.totalTablasJSON = 0;
      for (let i = 0; i < this.tablasJSON.length; i++) {
        const tablaJSON = this.tablasJSON[i];
        this.totalTablasJSON++;
        let encontrado = false;
        if (this.permitido(tablaJSON.nombrePermiso)) {
          loopj: for (let j = 0; j < this.contentLayout.length; j++) {
            const contentLayoutItem = this.contentLayout[j];
            if (
              contentLayoutItem.c === "Tabla" &&
              contentLayoutItem.idComponent === tablaJSON.id
            ) {
              encontrado = true;
              break loopj;
            }
          }
          if (!encontrado) {
            this.tablasDisponibles.push(tablaJSON);
          }
        }
      }
    },
    generateDropdownItems() {
      // Obtenemos los elementos que se pueden mostrar
      // Vaciamos los elementos y los volvemos a regenerar
      while (this.dropdownItems.length > 0) {
        this.dropdownItems.pop();
      }

      // Anhadimos las pildoras
      this.getPildorasDisponibles();
      let pildoras = new Object();
      pildoras.name = this.$t("lang.home.pildoras");
      pildoras.id = 1;
      pildoras.icon = "glyphicon glyphicon-info-sign";
      pildoras.disabled = false;
      let pildorasList = [];
      this.pildorasDisponibles.forEach(pildorasDisponiblesItem => {
        pildorasList.push({
          name:
            String(pildorasDisponiblesItem.bip_id) +
            ". " +
            // this.$t(`lang.pildora.pil_${pildorasDisponiblesItem.bip_id}`),
            pildorasDisponiblesItem.bip_titulo,
          id: pildorasDisponiblesItem.bip_id,
          disabled: false
        });
      });
      if (pildorasList.length <= 0) {
        pildorasList.push({
          name: this.$t("lang.comun.noelementos"),
          id: 0,
          disabled: true
        });
      }
      pildoras.children = pildorasList;
      this.dropdownItems.push(pildoras);

      // Anhadimos los echarts
      this.getEChartsDisponibles();
      let echarts = new Object();
      echarts.name = this.$t("lang.home.graficos");
      echarts.id = 2;
      echarts.icon = "glyphicon glyphicon-stats";
      echarts.disabled = false;
      let echartsList = [];
      this.echartsDisponibles.forEach(echartsDisponiblesItem => {
        echartsList.push({
          name:
            String(echartsDisponiblesItem.id) +
            ". " +
            // this.$t(`lang.echart.echart_${echartsDisponiblesItem.id}`),
            echartsDisponiblesItem.titulo,
          id: echartsDisponiblesItem.id,
          disabled: false
        });
      });
      if (echartsList.length <= 0) {
        echartsList.push({
          name: this.$t("lang.comun.noelementos"),
          id: 0,
          disabled: true
        });
      }
      echarts.children = echartsList;
      this.dropdownItems.push(echarts);

      // Anhadimos Tabla
      if (process.env.VUE_APP_BI_METAVISTA == 'true') {
        this.getTablasDisponibles();
        let tablas = new Object();
        tablas.name = this.$t("lang.home.metavistas");
        tablas.id = 4;
        tablas.icon = "glyphicon glyphicon-list-alt";
        tablas.disabled = false;

        let tablasList = [];
        this.tablasDisponibles.forEach(tablasDisponiblesItem => {
          tablasList.push({
            name:
              String(tablasDisponiblesItem.id) +
              ". " +
              // this.$t(`lang.tabla.tabla_${tablasDisponiblesItem.id}`),
              tablasDisponiblesItem.titulo,
            id: tablasDisponiblesItem.id,
            disabled: false
          });
        });
        if (tablasList.length <= 0) {
          tablasList.push({
            name: this.$t("lang.comun.noelementos"),
            id: 0,
            disabled: true
          });
        }
        tablas.children = tablasList;
        this.dropdownItems.push(tablas);
      }
      // Anhadimos Top Articulos vendidos
      let topArticulosVendidos = new Object();
      topArticulosVendidos.name = this.$t("lang.home.toparticulosvendidos");
      topArticulosVendidos.id = 3;
      topArticulosVendidos.icon = "glyphicon glyphicon-fire";
      // Comprobamos si ya está anhadido
      let encontrado = false;
      loop: for (let i = 0; i < this.contentLayout.length; i++) {
        if (this.contentLayout[i].c === "TopArticulosVendidos") {
          encontrado = true;
          break loop;
        }
      }
      topArticulosVendidos.disabled = encontrado;
      this.dropdownItems.push(topArticulosVendidos);

      // TODO: falta el tema de los usuarios y parent ops para ver que tiendas saca
      // //añadimos los elementos del phone services
      // let phoneServices = new Object()
      // phoneServices.name = "Tablas"
      // phoneServices.id = 5;
      // phoneServices.icon = "glyphicon glyphicon-th-list";
      // phoneServices.disabled = false;

      // let phoneServicesSub = [];
      // let encontradoVentaNeta, encontradoAnalisisTienda = false, encontradoAnalisisSeccion = false
      // for (let j = 0; j < this.contentLayout.length; j++) {
      //   if (this.contentLayout[j].idComponent === 1 && this.contentLayout[j].c === "VentaNeta") {
      //     encontradoVentaNeta = true
      //   }
      //   if (this.contentLayout[j].idComponent === 2 && this.contentLayout[j].c === "AnalisisTienda") {
      //     encontradoAnalisisTienda = true
      //   }
      //   if (this.contentLayout[j].idComponent === 3 && this.contentLayout[j].c === "AnalisisSeccion") {
      //     encontradoAnalisisSeccion = true
      //   }
      // }
      // if (!encontradoVentaNeta) {
      //   phoneServicesSub.push({
      //     name: String(1) + ". " + "Venta neta",
      //     c: "VentaNeta",
      //     id: 1,
      //     disabled: false
      //   })
      // }
      // if (!encontradoAnalisisTienda) {
      //   phoneServicesSub.push({
      //     name: String(2) + ". " + "Analisis tienda",
      //     c: "AnalisisTienda",
      //     id: 2,
      //     disabled: false
      //   })
      // }
      // if (!encontradoAnalisisSeccion) {
      //   phoneServicesSub.push({
      //     name: String(2) + ". " + "Analisis seccion",
      //     c: "AnalisisSeccion",
      //     id: 3,
      //     disabled: false
      //   })
      // }
      // if (phoneServicesSub.length <= 0) {
      //   phoneServicesSub.push({
      //     name: this.$t("lang.comun.noelementos"),
      //     id: 0,
      //     disabled: true
      //   });
      // }
      // phoneServices.children = phoneServicesSub;
      // this.dropdownItems.push(phoneServices);
    },
    addPildoraDashboard(id) {
      // Buscamos la pildora del archivo JSON por medio del id
      let pildoraToAdd = new Object();
      loop: for (let i = 0; i < this.pildorasJSON.length; i++) {
        if (this.pildorasJSON[i].bip_id === id) {
          let config = new Object();
          config.id = id;
          config.tipo = "pildora";
          // config.name = this.$t(`lang.pildora.pil_${id}`);
          config.name = this.pildorasJSON[i].bip_titulo;
          config.color = this.pildorasJSON[i].bip_color;
          config.conGrafico = this.pildorasJSON[i].bip_conGrafico;
          config.tipoGrafico = this.pildorasJSON[i].bip_tipoGrafico;
          config.decimales = this.pildorasJSON[i].bip_decimales;
          config.tipoDato = this.pildorasJSON[i].bip_tipoDato;
          config.tipoDato2 = this.pildorasJSON[i].bip_tipoDato2;
          config.tipoDato3 = this.pildorasJSON[i].bip_tipoDato3;
          // config.conValor2 = this.pildorasJSON[i].bip_conValor2;
          // config.conValor3 = this.pildorasJSON[i].bip_conValor3;
          config.numElemGraf = this.pildorasJSON[i].bip_numElemGraf;

          pildoraToAdd.config = config;
          pildoraToAdd.collapsed = false;
          pildoraToAdd.x = this.siguientePosicionPequenha.x;
          pildoraToAdd.y = this.siguientePosicionPequenha.y;
          pildoraToAdd.w = this.widthPildora;
          pildoraToAdd.h = this.heightPildora;
          pildoraToAdd.i = String("p" + id);
          pildoraToAdd.idComponent = id;
          pildoraToAdd.c = "Pildora";
          pildoraToAdd.nombrePermiso = this.pildorasJSON[i].bip_nombrePermiso;

          /*if (!isNaN(this.bip_item_id)){
            // Obtenemos los datos
            biApiService
              .getPildoraByIdAndItemIds(id, this.bip_item_id)
              .then(data => {
                pildoraToAdd.data = data;
                util.mostrarEnConsola(
                  "Dashboard - getPildoraByIdAndItemIds",
                  data,
                  "OK"
                );
              })
              .catch(error => {
                pildoraToAdd.data = null;
                util.mostrarEnConsola(
                  "Dashboard - getPildoraByIdAndItemIds",
                  error,
                  "ERROR"
                );
              });
          }
          else{*/
            // Obtenemos los datos
            biApiService
              .getPildoraByIdAndItemId(id, this.bip_item_id)
              .then(data => {
                pildoraToAdd.data = data;
                // util.mostrarEnConsola(
                //   "Dashboard - getPildoraByIdAndItemId",
                //   data,
                //   "OK"
                // );
              })
              .catch(error => {
                pildoraToAdd.data = null;
                util.mostrarEnConsola(
                  "Dashboard - getPildoraByIdAndItemId",
                  error,
                  "ERROR"
                );
              });
          
          break loop;
          
        }
      }
      // Anhadimos la pildora al contentLayout
      this.contentLayout.push(pildoraToAdd);

      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    addEchartDashboard(id) {
      // Buscamos la pildora del archivo JSON por medio del id
      let echartToAdd = new Object();
      loop: for (let i = 0; i < this.echartsJSON.length; i++) {
        if (this.echartsJSON[i].id === id) {
          echartToAdd.id = id;
          echartToAdd.tipo = "echart";
          echartToAdd.name = this.$t(`lang.echart.echart_${id}`);
          echartToAdd.color = this.echartsJSON[i].color;
          echartToAdd.config = this.echartsJSON[i].config;
          echartToAdd.collapsed = false;
          echartToAdd.x = this.siguientePosicionGrande.x;
          echartToAdd.y = this.siguientePosicionGrande.y;
          echartToAdd.w = this.widthEChart;
          echartToAdd.h = this.heightEChart;
          echartToAdd.hReverse = this.heightEChart;
          echartToAdd.i = String("e" + id);
          echartToAdd.idComponent = id;
          echartToAdd.c = "EChart"; // Tiene que tener el mismo nombre que el componente .vue
          echartToAdd.nombrePermiso = this.echartsJSON[i].nombrePermiso;

          biApiService
            .getGraficoByIdsAndItemId(id, this.bip_item_id)
            .then(data => {
              /**
               * En data existe un campo llamado fila, que indica la serie que se va a rellenar
               * En el JSON tambien se indica dicho campos, asi que se va rellenando las series por cada fila
               */
              
              let series = [];
              let serieToAdd = new Object();
              for (let k = 0; k < data.length; k++) {
                serieToAdd = this.echartsJSON[i].config.series[k];
                let arrayDatos = [];

                  // Sacamos los datos de la grafica del objeto
                  for (let key in data[k]) {
                    if (String(key).includes("big_col_") && !String(key).includes("txt")) {
                      let valor = new Object();
                      valor.id = Number(key.split("_").pop());
                      valor.value = Number(data[k][key]);
                      arrayDatos.push(valor);
                    }
                  }

                  // Ordenamos los datos
                  arrayDatos.sort(this.compare);

                  //añadimos el nombre la serie para la leyenda
                  if (serieToAdd.name =="" || serieToAdd.name ==null)
                    serieToAdd.name= data[k].big_col_1_txt;
                  
                  serieToAdd.fila= data[k].big_fila;

                  // Recorremos los datos ordenados y los metemos en el array dentro del config
                  arrayDatos.forEach(valor => {
                    serieToAdd.data.push(valor.value);
                  });

                  // Agregamos los datos
                  series.push(serieToAdd);
              }
              // Agregamos las series al echart
              echartToAdd.config.series = series;
              // util.mostrarEnConsola(
              //   "Dashboard - getGraficoByIdsAndItemId",
              //   data.length,
              //   "OK"
              // );
            })
            .catch(error => {
              echartToAdd.data = null;
              util.mostrarEnConsola(
                "Dashboard - getGraficoByIdsAndItemId",
                error,
                "ERROR"
              );
            });
          break loop;
        }
      }
      // Anhadimos la pildora al contentLayout
      this.contentLayout.push(echartToAdd);
      //regeneramos los datosde todos los graficos
      this.getAllGraficosByIdsAndItemId()
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    compare: function(a, b) {
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      return 0;
    },
    addTopArticulosVendidosDashboard() {
      let topArticulosVendidosToAdd = new Object();
      topArticulosVendidosToAdd.x = this.siguientePosicionGrande.x;
      topArticulosVendidosToAdd.y = this.siguientePosicionGrande.y;
      topArticulosVendidosToAdd.w = this.widthTopArticulosVendidos;
      topArticulosVendidosToAdd.h = this.heightTopArticulosVendidos;
      topArticulosVendidosToAdd.i = String("tav1");
      topArticulosVendidosToAdd.idComponent = 3;
      topArticulosVendidosToAdd.c = "TopArticulosVendidos";
      topArticulosVendidosToAdd.config = new Object();
      topArticulosVendidosToAdd.config.id = 3;
      topArticulosVendidosToAdd.config.tipo = "toparticulosvendidos";
      topArticulosVendidosToAdd.nombrePermiso = "MOBILESTORE.BI.TOPVENTAS";

      // Obtenemos los articulos vendidos
      biApiService
        .getAllMejoresVentasOp(this.bip_item_id)
        .then(data => {
          topArticulosVendidosToAdd.data = data;
          // util.mostrarEnConsola(
          //   "Dashboard - getAllMejoresVentasOp",
          //   data.length,
          //   "OK"
          // );
        })
        .catch(error => {
          topArticulosVendidosToAdd.data = null;
          util.mostrarEnConsola(
            "Dashboard - getAllMejoresVentasOp",
            error,
            "ERROR"
          );
        });

      // Anhadimos la pildora al contentLayout
      this.contentLayout.push(topArticulosVendidosToAdd);

      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    addTablaDashboard(id) {
      // Buscamos la tabla del archivo JSON por medio del id
      let tablaToAdd = new Object();
      let idtienda = 0;
        loop: for (let i = 0; i < this.tablasJSON.length; i++) {
          if (this.tablasJSON[i].id === id) {
            tablaToAdd.x = this.siguientePosicionGrande.x;
            tablaToAdd.y = this.siguientePosicionGrande.y;
            tablaToAdd.w = this.widthTabla;
            tablaToAdd.h = this.heightTabla;
            tablaToAdd.hReverse = this.heightTabla;
            tablaToAdd.i = String("t" + id);
            tablaToAdd.idComponent = id;
            tablaToAdd.c = "Tabla";
            tablaToAdd.config = this.tablasJSON[i].config;
            tablaToAdd.nombrePermiso = this.tablasJSON[i].nombrePermiso;
            tablaToAdd.collapsed = false;
            tablaToAdd.config.nombre = this.$t(
              `lang.tabla.tabla_${this.tablasJSON[i].id}`
            );
            if (tablaToAdd.config.filtroid === "S") {
              idtienda= this.bip_item_id;
            } 
            tablaToAdd.data=[];
            // Obtenemos la informacion
            biApiService
              .getAllMetavistaByDirIdAndId(idtienda, id)
              .then(data => {
                if (data !== "") {
                  tablaToAdd.data = data;
                }
              })
              .catch(error => {
                tablaToAdd.data = [];
                util.mostrarEnConsola(
                  "Dashboard - getAllMetavistaByDirIdAndId",
                  error,
                  "ERROR"
                );
              });
            break loop;
          }
       }
        // Anhadimos la tabla al contentLayout
      this.contentLayout.push(tablaToAdd);

      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
     },
    addPhoneServiceDashboard (child) {
        // Buscamos la tabla del archivo JSON por medio del id
      let phoneToAdd = new Object();
     
      phoneToAdd.x = this.siguientePosicionGrande.x;
      phoneToAdd.y = this.siguientePosicionGrande.y;
      phoneToAdd.w = this.widthPhone;
      phoneToAdd.h = this.heightPhone;
      phoneToAdd.hReverse = this.heightPhone;
      phoneToAdd.i = String("ps" + child.id);
      phoneToAdd.idComponent = child.id;
      phoneToAdd.c = child.c;
      // phoneToAdd.config = this.tablasJSON[i].config;
      //phoneToAdd.nombrePermiso = this.tablasJSON[i].nombrePermiso;
      phoneToAdd.config =  new Object()
      phoneToAdd.config.id = child.id;
      phoneToAdd.config.tipo = "phoneservices";
      phoneToAdd.collapsed = false;

      // Anhadimos la tabla al contentLayout
      this.contentLayout.push(phoneToAdd);

      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removePildoraDashboard(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "Pildora"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeEChartDashboard(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "EChart"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeTopArticulosVendidos(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "TopArticulosVendidos"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeTabla(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "Tabla"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeVentaNeta(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "VentaNeta"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeAnalisisSeccion(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "AnalisisSeccion"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    removeAnalisisTienda(id) {
      // Buscamos la pildora en el array y la quitamos
      loop: for (let j = 0; j < this.contentLayout.length; j++) {
        if (
          this.contentLayout[j].idComponent === id &&
          this.contentLayout[j].c === "AnalisisTienda"
        ) {
          // Modificamos el contenido del array en la posicion j
          this.contentLayout.splice(j, 1);
          break loop;
        }
      }
      // Regeneramos el dropdown de elementos
      this.generateDropdownItems();

      // Recalculamos la altura del panel-body
      this.calculategridLayoutHeight();

      // Recalculamos la siguiente posicion
      this.getSiguientePosicionItem();
    },
    calculategridLayoutHeight() {
      // Obtenemos la matriz de ocupacion y calculamos cuantas lineas estan ocupadas
      let matrizOcupacion = this.getMatrizOcupacion();
      let alturaTotal = 0;
      for (let y = 0; y < matrizOcupacion.length; y++) {
        loopx: for (let x = 0; x < matrizOcupacion[y].length; x++) {
          if (matrizOcupacion[y][x]) {
            alturaTotal++;
            break loopx;
          }
        }
      }
      if (alturaTotal !== 0) {
        let alturaPixels = alturaTotal * (this.contentConfig.rowHeight + 40);
        this.gridLayoutHeight = alturaPixels +50;
      }
    },
    refrescarDataPildoras() {
      // Recorremos el contentLayout y modificamos el campo data de cada pildora
      if (this.contentLayout.length > 0) {
        this.contentLayout.forEach(contentLayoutItem => {
          if (contentLayoutItem.c === "Pildora") {
            let refresDatos=false;
            this.pildoraDataList.forEach(pildoraDataListItem => {
              if (
                contentLayoutItem.idComponent === pildoraDataListItem.bip_id
              ) {
                contentLayoutItem.data = pildoraDataListItem;
                refresDatos=true;
              }
            });
            if (!refresDatos){
              // console.log(contentLayoutItem.data);
              contentLayoutItem.data = null;
            }
          }
        });
      }
    },
    getAllPildoraByIdsAndItemId() {
      if (this.contentLayout.length > 0) {
        // Obtenemos la lista ids de las pildoras a mostrar y las metemos en un array
        let listaIds = [];
        this.contentLayout.forEach(contentLayoutItem => {
          if (contentLayoutItem.c === "Pildora") {
            listaIds.push(contentLayoutItem.idComponent);
          }
        });
        // Si hay alguna pildora seleccionada
        if (listaIds.length > 0) {
          let idshm = new Object();
          idshm[Number(this.bip_item_id)] = listaIds;
          biApiService
            .getAllPildoraByIdsAndItemId(idshm)
            .then(data => {
              if (data) {
                this.pildoraDataList = data;
                this.refrescarDataPildoras();
              } else {
                this.pildorasList = []
              }   
            })
            .catch(error => {
              this.pildoraDataList = []
              this.refrescarDataPildoras();
              util.mostrarEnConsola(
                "Dashboard - getAllPildoraByIdsAndItemId",
                error,
                "ERROR"
              );
            });
        } else {
          util.mostrarEnConsola(
            "Dashboard - getAllPildoraByIdsAndItemId",
            "No se han seleccionado pildoras",
            "OK"
          );
        }
      } else {
        util.mostrarEnConsola(
          "Dashboard - getAllPildoraByIdsAndItemId",
          "No se han seleccionado pildoras",
          "OK"
        );
      }
    },
    getAllMejoresVentasOp() {
      // Primero comprobamos si esta el complemento anhadido
      if (this.contentLayout.length > 0) {
        let hayTopArticulosVendidos = false;
        loop: for (let i = 0; i < this.contentLayout.length; i++) {
          const contentLayoutItem = this.contentLayout[i];
          if (contentLayoutItem.c === "TopArticulosVendidos") {
            hayTopArticulosVendidos = true;
            break loop;
          }
        }
        if (hayTopArticulosVendidos) {
          // Obtenemos los datos del servidor y actualizamos los datos del elemento
          biApiService
            .getAllMejoresVentasOp(this.bip_item_id)
            .then(data => {
              // Una vez obtenidos los datos recorremos el layout
              loop: for (let i = 0; i < this.contentLayout.length; i++) {
                const contentLayoutItem = this.contentLayout[i];
                if (contentLayoutItem.c === "TopArticulosVendidos") {
                  contentLayoutItem.data = data;
                  break loop;
                }
              }
              // util.mostrarEnConsola(
              //   "Dashboard - getAllMejoresVentasOp",
              //   data.length,
              //   "OK"
              // );
            })
            .catch(error => {
              this.cambiarSpinner(false);
              util.mostrarEnConsola(
                "Dashboard - getAllMejoresVentasOp",
                error,
                "ERROR"
              );
            });
        } else {
          util.mostrarEnConsola(
            "Dashboard - getAllMejoresVentasOp",
            "No se ha seleccionado el complemento",
            "OK"
          );
        }
      } else {
        util.mostrarEnConsola(
          "Dashboard - getAllMejoresVentasOp",
          "No se ha seleccionado el complemento",
          "OK"
        );
      }
    },
    getAllGraficosByIdsAndItemId() {
      if (this.contentLayout.length > 0) {
        // Obtenemos la lista ids de los graficos a mostrar y las metemos en un array
        let listaIds = [];
        this.contentLayout.forEach(contentLayoutItem => {
          if (contentLayoutItem.c === "EChart") {
            listaIds.push(contentLayoutItem.idComponent);
          }
        });

        // Si hay algun grafico seleccionada
        if (listaIds.length > 0) {
          // Generamos el hashmap
          let idshm = new Object();
          idshm[Number(this.bip_item_id)] = listaIds;

          biApiService
            .getAllGraficoByIdsAndItemId(idshm)
            .then(data => {
              this.graficoDataList = data;
              this.refrescarDataGraficos();
              // util.mostrarEnConsola(
              //   "Dashboard - getAllGraficoByIdsAndItemId",
              //   data.length,
              //   "OK"
              // );
            })
            .catch(error => {
              this.graficoDataList = [];
              this.refrescarDataGraficos();
              util.mostrarEnConsola(
                "Dashboard - getAllGraficoByIdsAndItemId",
                error,
                "ERROR"
              );
            });
        } else {
          util.mostrarEnConsola(
            "Dashboard - getAllGraficoByIdsAndItemId",
            "No hay ningun grafico/echart seleccionado",
            "OK"
          );
        }
      }
    },
    getAllTablaByIdsAndItemId() {
      if (this.contentLayout.length > 0) {
        // Obtenemos la lista de tablas/metavistas que hay en el contentLayout
        let listaIds = [];
        this.contentLayout.forEach(contentLayoutItem => {
          if (contentLayoutItem.c === "Tabla") {
            listaIds.push({ id: contentLayoutItem.idComponent, filtroid: contentLayoutItem.config.filtroid });
          }
        });

        // Si hay algun grafico seleccionada
        if (listaIds.length > 0) {
          /**
           * Debido a que cada metavista corresponde a una tabla diferente en la base de datos,
           * no se puede modularizar como los demas complemenos, por ello se realizan tantas llamadas
           * al ws como diferentes metavistas haya seleccionadas y se actualizan los datos uno por uno.
           * */
          let idtienda;
          for (let i = 0; i < listaIds.length; i++) {
            // Obtenemos la informacion
            idtienda = 0;
            if (listaIds[i].filtroid === "S") {
              idtienda= this.bip_item_id;
            } 
            biApiService
              .getAllMetavistaByDirIdAndId(idtienda, listaIds[i].id)
              .then(data => {
                if (data !=="") {
                  // Buscamos la tabla del contentLayout correspondiente al id
                  for (let j = 0; j < this.contentLayout.length; j++) {
                    if (this.contentLayout[j].idComponent === listaIds[i].id && this.contentLayout[j].c === "Tabla") {
                      // Encontrada la tabla/metavista, actualizamos su data
                      // Primero limpimos
                      if (this.contentLayout[j].data != undefined && this.contentLayout[j].data !=null) {
                        while (this.contentLayout[j].data.length > 0) {
                          this.contentLayout[j].data.pop();
                        }
                      }
                      
                      this.contentLayout[j].data = data;                  
                    }
                  }
                }
                this.cambiarSpinner(false);
              })
              .catch(error => {
                for (let j = 0; j < this.contentLayout.length; j++) {
                  if (this.contentLayout[j].idComponent === listaIds[i].id && this.contentLayout[j].c === "Tabla") {
                    // Encontrada la tabla/metavista, actualizamos su data
                    // Primero limpimos
                    if (this.contentLayout[j].data != undefined && this.contentLayout[j].data !=null) {
                      while (this.contentLayout[j].data.length > 0) {
                        this.contentLayout[j].data.pop();
                      }
                    }                
                  }
                }
                this.cambiarSpinner(false);
                util.mostrarEnConsola(
                  "Dashboard - getAllMetavistaByDirIdAndId",
                  error,
                  "ERROR"
                );
              });
          }
        } else {
          this.cambiarSpinner(false);
          util.mostrarEnConsola(
            "Dashboard - getAllTablaByIdsAndItemId",
            "No hay ninguna tabla/metavista seleccionada",
            "ERROR"
          );
        }
      } else {
        this.cambiarSpinner(false);
        util.mostrarEnConsola(
          "Dashboard - getAllTablaByIdsAndItemId",
          "No hay ninguna tabla/metavista seleccionada",
          "ERROR"
        );
      }
    },
    refrescarDataGraficos() {
      // Recorremos el contentLayout y modificamos el campo data de cada pildora
      if (this.contentLayout.length > 0) {
        this.contentLayout.forEach(contentLayoutItem => {
          // Obtenemos todos los datos para dicho id de grafico
          if (contentLayoutItem.c === "EChart") {
            let datos = new Array();
            let encontrado = false;
            for (let i = 0; i < this.graficoDataList.length; i++) {
              if (
                this.graficoDataList[i].big_id === contentLayoutItem.idComponent
              ) {
                datos.push(this.graficoDataList[i]);
                encontrado = true;
              }
            }
            if (encontrado){
              datos.forEach(datosItem => {
                if (contentLayoutItem.idComponent === datosItem.big_id) {
                  // Hemos encontrado el grafico, recorremos las series
                  for (let j = 0;j < contentLayoutItem.config.series.length;j++) {
                    if (contentLayoutItem.config.series[j].fila === datosItem.big_fila) {
                      // Hemos encontrado la fila, actualizamos sus datos
                      let arrayDatos = [];
                      // TODO No esta bien, si hay nuevas marcas (series) entre tiendas o mas elementos?
                      // Sacamos los datos de la grafica del objeto
                      for (let key in datosItem) {
                        if (String(key).includes("big_col_") && !String(key).includes("txt")) {
                          let valor = new Object();
                          valor.id = Number(key.split("_").pop());
                          valor.value = Number(datosItem[key]);
                          arrayDatos.push(valor);
                        }
                      }

                      // Ordenamos los datos
                      arrayDatos.sort(this.compare);

                      // Recortamos el array con el numero de datos configurados
                      let arrayFinal = arrayDatos.slice(
                        0,
                        contentLayoutItem.config.series[j].numelements
                      );

                      // Vaciamos los datos
                      while (contentLayoutItem.config.series[j].data.length > 0) {
                        contentLayoutItem.config.series[j].data.pop();
                      }

                      // Recorremos los datos ordenados y los metemos en el array
                      arrayFinal.forEach(valor => {
                        contentLayoutItem.config.series[j].data.push(valor.value);
                      });
                    }
                  }
                }
              });
            } else {
              for (let j = 0;j < contentLayoutItem.config.series.length;j++) {
                 while (contentLayoutItem.config.series[j].data.length > 0) {
                        contentLayoutItem.config.series[j].data.pop();
                  }
              }
            }
          }
        });
      }
    },
    refrescarPhoneServices() {
      if (this.contentLayout.length > 0) {
        this.contentLayout.forEach(contentLayoutItem => {
          if (contentLayoutItem.c === "VentaNeta" || contentLayoutItem.c === "AnalisisTienda" || contentLayoutItem.c === "AnalisisSeccion") {
           this.refrescar += 1
          }
        })
      }
    }
  }
};
</script>